import * as React from 'react';
import { useSelector } from 'react-redux';

import { isNewbuildingConsultantPopupOpen } from '../../selectors/newbuildingConsultant';
import { ConsultantPopupContainerLoadable } from './loadable';

export function ConsultantPopupContainerWrapper() {
  const isOpen = useSelector(isNewbuildingConsultantPopupOpen);

  if (!isOpen) {
    return null;
  }

  return <ConsultantPopupContainerLoadable />;
}
